import { captureException } from '@sentry/nextjs'
import { useMutation, UseMutationOptions } from 'react-query'
import { ApiClient } from 'services/ApiClient'
import { Api } from 'types/Api'
import { DiscountBanner } from 'models/Discount'

export namespace FetchEvaluatedDiscount {
  export type Response = DiscountBanner
  export type Variables = {
    storedDiscountCode?: string
    searchDiscountCode?: string
  }
  export type Error = Api.Error
  export type Options = UseMutationOptions<Response, Error, Variables>
}

export const useFetchEvaluatedDiscount = (
  options?: FetchEvaluatedDiscount.Options
) => {
  const mutationFn = async (data: FetchEvaluatedDiscount.Variables) => {
    return ApiClient.post<FetchEvaluatedDiscount.Response>('/v1/discounts/evaluate', {
      data,
    })
  }

  const mutation = useMutation<
    FetchEvaluatedDiscount.Response,
    FetchEvaluatedDiscount.Error,
    FetchEvaluatedDiscount.Variables
  >(mutationFn, {
    ...options,
    onError: (error) => {
      console.log(error)
      captureException(error)
    },
  })

  return { ...mutation, fetchEvaluatedDiscount: mutation.mutate }
}
